<div *ngIf="isLoading" class="loading-container" style=" margin-top:100px; height: 900px;">
  <div class="progress progress-indeterminate">
    <div class="progress-bar" style="background-color: #06c;" role="progressbar"></div>
  </div>
</div>
<div *ngIf="!isLoading">
  <div *ngFor="let item of data">
    <div *ngIf="item.visible" class="trasparenza-menu-item" [attr.data-url]="item.link" (click)="navigate(item, $event)"
      [ngClass]="{'trasparenza-active': item.selected}">
      <div class="menu-title" [attr.data-url]="item.link" [ngClass]="{'menu-parent-title': level === 0}">
        {{ item.title }}
        <i *ngIf="item.below.length > 0" class="fa fa-angle-down fa-lg trasparenza-arrow" [class.rotate]="item.opened"
          (click)="toggleMenu(item, $event)">
        </i>
      </div>
    </div>
    <ng-container *ngIf="item.below.length > 0">
      <div class="trasparenza-submenu level-{{ level }}" [ngClass]="{'opened': item.opened}">
        <tree-menu [data]="item.below" [level]="level + 1"></tree-menu>
      </div>
    </ng-container>
  </div>
</div>